"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classcat_1 = require("classcat");
var TableContext_1 = require("./TableContext");
var Virtualized_1 = require("./Virtualized");
var theme = require("./theme.module.scss");
var utils_1 = require("./utils");
var ResizeContext_1 = require("./ResizeContext");
var StickyScrollbar_1 = require("./StickyScrollbar");
function defaultRenderResizer(left, width) {
    return React.createElement("div", { className: theme.resizer, style: { left: left, width: width } });
}
var Table = React.forwardRef(function (_a, ref) {
    var onColumnResize = _a.onColumnResize, rowHeight = _a.rowHeight, itemsCount = _a.itemsCount, renderRow = _a.renderRow, viewportHeight = _a.viewportHeight, viewportWidth = _a.viewportWidth, viewportRows = _a.viewportRows, overscanItems = _a.overscanItems, extraData = _a.extraData, calculateInitialWidth = _a.calculateInitialWidth, renderHeader = _a.renderHeader, renderFooter = _a.renderFooter, onScroll = _a.onScroll, onBeforeScrollEnd = _a.onBeforeScrollEnd, className = _a.className, enableColumnResizing = _a.enableColumnResizing, _b = _a.minColumnWidth, minColumnWidth = _b === void 0 ? 100 : _b, _c = _a.maxColumnWidth, maxColumnWidth = _c === void 0 ? Infinity : _c, freezeColumnIndex = _a.freezeColumnIndex, _d = _a.renderResizer, renderResizer = _d === void 0 ? defaultRenderResizer : _d, _e = _a.disableResizer, disableResizer = _e === void 0 ? true : _e, useStickyScrollbar = _a.useStickyScrollbar;
    var _f = React.useState({
        width: 0,
        left: 0,
        enabled: false
    }), resize = _f[0], setResize = _f[1];
    var containerRef = React.useRef();
    var viewport = React.useRef();
    var container = (ref || containerRef);
    var setResizeHandler = React.useCallback(function (enabled, _a) {
        var left = _a.left, width = _a.width, index = _a.index;
        window.requestAnimationFrame(function () {
            var offsetLeft = container.current.offsetLeft;
            var nextWidth = utils_1.clampValue(width, [minColumnWidth, maxColumnWidth]);
            setResize({ enabled: enabled, left: left - offsetLeft, width: nextWidth });
            onColumnResize && onColumnResize(index, nextWidth);
        });
    }, [minColumnWidth, maxColumnWidth, onColumnResize]);
    var resizeContextValue = React.useMemo(function () { return ({
        setResizeHandler: setResizeHandler
    }); }, [setResizeHandler]);
    var tableContextValue = React.useMemo(function () { return ({
        freezeColumnIndex: freezeColumnIndex,
        minColumnWidth: minColumnWidth,
        maxColumnWidth: maxColumnWidth
    }); }, [
        freezeColumnIndex,
        minColumnWidth,
        maxColumnWidth
    ]);
    return (React.createElement(TableContext_1.default.Provider, { value: tableContextValue },
        React.createElement("div", { ref: container, className: classcat_1.default([theme.table, className]), style: {
                pointerEvents: resize.enabled ? "none" : "all"
            } },
            enableColumnResizing && resize.enabled && !disableResizer && renderResizer(resize.left, resize.width),
            React.createElement(ResizeContext_1.default.Provider, { value: resizeContextValue },
                React.createElement(Virtualized_1.default, tslib_1.__assign({}, {
                    ref: viewport,
                    rowHeight: rowHeight,
                    itemsCount: itemsCount,
                    renderRow: renderRow,
                    viewportHeight: viewportHeight,
                    viewportWidth: viewportWidth,
                    viewportRows: viewportRows,
                    overscanItems: overscanItems,
                    extraData: extraData,
                    calculateInitialWidth: calculateInitialWidth,
                    renderHeader: renderHeader,
                    renderFooter: renderFooter,
                    onScroll: onScroll,
                    onBeforeScrollEnd: onBeforeScrollEnd
                })))),
        (useStickyScrollbar) && (React.createElement(StickyScrollbar_1.default, { extraData: extraData, target: viewport }))));
});
exports.default = React.memo(Table);
